import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const f = l((i, o) => /* @__PURE__ */ e.jsx(
  t,
  {
    ref: o,
    ...i,
    image: (s) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#1D1D44",
            fillRule: "evenodd",
            d: "M8.341 16c-.615-.95-.93-2.64-1.34-2.495s-.473.153-1.268.363c-1.835.486-2.807.228-2.711-.53.13-1.022-.217-1.274-.217-1.274s-.49-.076-.49-.479.242-.373.242-.373-.208-.135-.36-.299.117-.411.117-.411.446-.196.243-1.16c0 0-.197-.054-.504-.184-.6-.254-.456-.571 0-1.008.504-.484.969-1.259.969-1.704 0-.27.008-1.22 0-1.458-.03-.878.092-2.13.969-3.029C5.589.32 7.543-.359 10.257.184s3.538 2.271 4.124 4.086c.587 1.815 0 3.194-.729 4.59-.415.797-1.383 1.822-1.116 3.204.184.954 1.116 2.694 1.116 2.694",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
f.displayName = "LeftFacingSelfieIcon";
export {
  f as LeftFacingSelfieIcon,
  f as default
};
//# sourceMappingURL=index.js.map
